import type { PlacementGroup } from '@/modules/adv/ad-service'
import {
    INDEX_EXCHANGE,
    MEDIA_NET_MULTIFORMAT,
    ONETAG,
    OMNIDEX_VIDEO,
    PLAYGAMA_FALLBACK,
    TAPPX_VIDEO,
    LOOPME,
    GENIEE,
    ADITUDE_VIDEO,
    EQUATIV,
    INMOBI_VIDEO,
} from '@/modules/adv/header-bidding/prebid/bidders-config'
import { type AdProvidersSettings, type PlatformType, type EffectiveType } from '@/types'

import { getCommonProvidersAdSettings } from './common-providers-settings'
import { createHeaderBiddingAdSettings } from './provider-factories'
import { filterAdProviderSettings } from './utils'

export function getPortalAdSettings({
    gamAccount,
    platform,
    effectiveType,
}: {
    gamAccount: string
    platform: PlatformType
    effectiveType: EffectiveType | undefined
}): PlacementGroup<AdProvidersSettings>[] {
    const common = getCommonProvidersAdSettings(gamAccount, platform)

    return [
        {
            placements: ['*'],
            settings: [common.GOOGLE_AD_PORTAL_SETTINGS, common.HEADER_BIDDING_AD_BANNER_FALLBACK_PROVIDER_SETTINGS],
        },
        {
            placements: ['interstitial', 'interstitial_midroll', 'interstitial_preroll', 'rewarded'],
            settings: [
                ...filterAdProviderSettings(effectiveType, [
                    common.GOOGLE_AD_GAME_PAGE_SETTINGS_REWARDED_FORMAT,
                    common.GOOGLE_INSTREAM_GAME_PAGE_SETTINGS,
                    common.GOOGLE_AD_GAME_PAGE_SETTINGS_INTERSTITIAL_FORMAT,
                    common.GOOGLE_BANNER_GAME_PAGE_SETTINGS,
                ]),
                createHeaderBiddingAdSettings(platform, [
                    TAPPX_VIDEO,
                    MEDIA_NET_MULTIFORMAT,
                    ONETAG,
                    GENIEE,
                    ADITUDE_VIDEO,
                    OMNIDEX_VIDEO,
                    LOOPME,
                    INMOBI_VIDEO,
                    EQUATIV,
                    INDEX_EXCHANGE,
                    PLAYGAMA_FALLBACK,
                ]),
            ],
        },
    ]
}
